// Assign peer form — admin assigns a peer to a user

import { useEffect, useState } from "react";
import { useLocation, useParams } from "wouter";
import { api, type Peer } from "../lib/api-client.js";
import { usePeerStore } from "../stores/peers.js";

export function PeerAssign() {
	const { ip } = useParams<{ ip: string }>();
	const [, setLocation] = useLocation();
	const { assignPeer } = usePeerStore();

	const [peer, setPeer] = useState<Peer | null>(null);
	const [assignedTo, setAssignedTo] = useState("");
	const [notes, setNotes] = useState("");
	const [submitting, setSubmitting] = useState(false);
	const [error, setError] = useState<string | null>(null);

	useEffect(() => {
		if (ip) {
			api.getPeer(ip).then(({ peer }) => setPeer(peer)).catch((err) => setError(err.message));
		}
	}, [ip]);

	const handleSubmit = async (e: React.FormEvent) => {
		e.preventDefault();
		if (!ip || !assignedTo.trim()) return;

		setSubmitting(true);
		setError(null);

		try {
			await assignPeer(ip, assignedTo.trim(), notes.trim() || undefined);
			setLocation("/");
		} catch (err) {
			setError((err as Error).message);
		} finally {
			setSubmitting(false);
		}
	};

	return (
		<div>
			<h1 className="page-title">Assign Peer</h1>

			{error && (
				<div className="card" style={{ color: "var(--color-error)", marginBottom: "var(--space-4)" }}>
					{error}
				</div>
			)}

			{peer && (
				<div className="card" style={{ maxWidth: "500px" }}>
					<div style={{ marginBottom: "var(--space-4)" }}>
						<strong>IP:</strong> <span className="mono">{peer.ipAddress}</span>
						{" — "}
						<strong>Status:</strong> {peer.status}
					</div>

					<form onSubmit={handleSubmit}>
						<div className="form-group">
							<label className="form-label" htmlFor="assignedTo">
								Assign To (email)
							</label>
							<input
								id="assignedTo"
								className="form-input"
								type="email"
								required
								value={assignedTo}
								onChange={(e) => setAssignedTo(e.target.value)}
								placeholder="user@example.com"
							/>
						</div>

						<div className="form-group">
							<label className="form-label" htmlFor="notes">
								Notes (optional)
							</label>
							<input
								id="notes"
								className="form-input"
								type="text"
								value={notes}
								onChange={(e) => setNotes(e.target.value)}
								placeholder="e.g., Laptop, office workstation"
							/>
						</div>

						<div style={{ display: "flex", gap: "var(--space-3)" }}>
							<button className="btn btn-primary" type="submit" disabled={submitting}>
								{submitting ? "Assigning..." : "Assign Peer"}
							</button>
							<button className="btn" type="button" onClick={() => setLocation("/")}>
								Cancel
							</button>
						</div>
					</form>
				</div>
			)}
		</div>
	);
}
